import './components/questionsAndAnswers';
import './components/more';
import './components/missionProject';
import './components/missionDonationModal';
import './components/js-form-validator';
import validatorOptions from './components/validatorOptions';


(function () {
  const donationForm = document.getElementById('donationForm');
  const submitButtons = donationForm.querySelectorAll('.form__submitButton');
  const validator = new Validator(
    donationForm,
    function (err, res) {
      return res;
    },
    validatorOptions
  );


  const radio = donationForm.querySelectorAll('input[name=donationForm__value]');
  const input = document.getElementById('donationForm__valueCustomValue');
  const radioCustom = document.getElementById("donationForm__valueCustom")

  input.addEventListener("click", () => {
    radioCustom.checked = true;
    if ('createEvent' in document) {
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', false, true);
      radioCustom.dispatchEvent(evt);
    } else radioCustom.fireEvent('onchange');
  });

  for (let i = 0; i < radio.length; i++) {
    radio[i].addEventListener('change', function (e) {
      if (this.value === 'custom') {
        // Parametry reguł rozdziela MYŚLNIK, nie dwukropek (js-form-validator.js:473).
        // Bez 'min-1' pole przyjmuje 'abc' i '0', a transakcję odrzuca dopiero bramka.
        input.dataset.rule = 'required|min-1';
      } else {
        input.dataset.rule = '';
      }
      validator.reload();
    });
  }

  for (const element of donationForm.elements) {
    element.addEventListener('change', function () {
      setTimeout(function () {
        if (validator.validate()) {
          for (const button of submitButtons) button.disabled = false;
        } else {
          for (const button of submitButtons) button.disabled = true;
        }
      }, 50);
    });

    element.addEventListener('keydown', function () {
      setTimeout(function () {
        if (validator.validate()) {
          for (const button of submitButtons) button.disabled = false;
        }
      }, 50);
    });
  }
})();
